import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import store from "./store";
import { initializeIcons } from "@uifabric/icons";
import "../node_modules/office-ui-fabric-react/dist/css/fabric.min.css";
import "./lib/polyfill";
import "./index.css";
import allSettled from "promise.allsettled";

/* if using design-suite, redirect to new domain design-tool */
if (window.location.hostname.includes("designsuite"))
  window.location.href = "https://www.designtool.ads-pipe.com";

/* if not using https, redirect automatically */
if (window.location.protocol !== "https:" && !window.location.hostname.includes("localhost"))
  window.location.href = "https:" + window.location.href.substring(window.location.protocol.length);

// Adding equal comparison of arrays
if (Array.prototype.equals)
  console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");

// eslint-disable-next-line no-extend-native
Array.prototype.equals = function( array ) {
  if (!array) return false;
  if (this.length !== array.length) return false;
  for (var i = 0, l = this.length; i < l; i++) {
    if (this[i] instanceof Array && array[i] instanceof Array) {
      if (!this[i].equals(array[i])) return false;
    } else if (this[i] !== array[i]) {
      return false;
    }
  }
  return true;
};

// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, "equals", { enumerable: false });

// Register icons and pull the fonts from the default SharePoint cdn.
initializeIcons();

const root = document.getElementById("root");
/* render the application */
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  root
);
/* register the service worker for offline capabilities */
registerServiceWorker();

// use allSettled shim for react-pdf compatibility
allSettled.shim();



// WEBPACK FOOTER //
// ./src/index.js